export enum ServedByOptionType {
  Account = 'Account',
  Sepa = 'Sepa',
}

export interface ServedByOption {
  label: string;
  value: ServedByOptionType;
  selected: boolean;
}
